import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const PlaneTake = _ref => {
  let {
      size = "16",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    d: "M2.00016 13.3451H14.0002V14.7935H2.00016V13.3451ZM14.3395 6.48483C14.2496 6.19146 14.0561 5.9489 13.8015 5.8105C13.547 5.67211 13.2522 5.64922 12.9822 5.74687L10.0002 6.82738L4.66683 4.65479L3.3335 5.37898L7.3335 8.27577L4.66683 9.72416L2.00016 8.27577L1.3335 8.99997L4.00016 11.8968L13.6982 7.94626C13.9584 7.84015 14.1706 7.62859 14.2902 7.35606C14.4098 7.08352 14.4274 6.77123 14.3395 6.48483Z",
    fill: color
  }));
};
export default PlaneTake;